document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("a.scroll-and-open").forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      const hash = this.getAttribute("href");
      const target = document.querySelector(hash);

      if (hash.length > 1 && target) {
        e.preventDefault();

        const details = target.querySelector("details.accordion-details");
        if (details && !details.open) {
          details.open = true;
          details.dispatchEvent(new Event("toggle"));
        }

        target.scrollIntoView({ behavior: "smooth", block: "center" });

        history.pushState(null, "", hash);
      }
    });
  });
});
